module.exports = __webpack_public_path__ + "img/shield-bios-banner-03.b478b80f.jpg";